<template>
    <div class="MSort">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>
    export default {
        name: 'MSort',
        data() {
            return {}
        },
        methods: {},
        filters: {},
        watch: {},
        computed: {},
        components: {}
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .MSort {
        max-width: 100vw;
    }
</style>